import { Form, Select } from "antd";
import { LabeledField } from "../labeledField/labeledField";

const { Option } = Select;

export const BillingTierField = ({
  jobTiers = [],
  disabled,
  isFormItem = true,
  extraLabel = null,
  style = {},
}) => {
  const renderField = () => (
    <Select
      showSearch
      allowClear
      optionFilterProp="children"
      placeholder="Billing Tier"
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
      disabled={disabled}
      style={style}
    >
      {jobTiers.map(({ id, name }) => (
        <Option key={id} value={id}>
          {name}
        </Option>
      ))}
    </Select>
  );

  if (isFormItem) {
    return (
      <Form.Item
        label="Billing Tier"
        name="jobTiersId"
        rules={[{ required: true, message: "Please select job tier!" }]}
      >
        {renderField()}
      </Form.Item>
    );
  }

  return (
    <LabeledField label="Billing Tier" required extra={extraLabel}>
      {renderField()}
    </LabeledField>
  );
};
